__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@blink/installer";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mui/material", "5.14.10", function() { return Promise.all([__webpack_require__.e(91), __webpack_require__.e(243), __webpack_require__.e(416), __webpack_require__.e(51)]).then(function() { return function() { return __webpack_require__(91); }; }); });
			register("@tanstack/react-query", "4.35.3", function() { return Promise.all([__webpack_require__.e(496), __webpack_require__.e(416), __webpack_require__.e(211)]).then(function() { return function() { return __webpack_require__(7496); }; }); });
			register("axios", "1.5.0", function() { return Promise.all([__webpack_require__.e(675), __webpack_require__.e(184)]).then(function() { return function() { return __webpack_require__(2675); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(456), __webpack_require__.e(416)]).then(function() { return function() { return __webpack_require__(456); }; }); });
			register("react-router-dom", "6.16.0", function() { return Promise.all([__webpack_require__.e(929), __webpack_require__.e(416), __webpack_require__.e(68)]).then(function() { return function() { return __webpack_require__(5929); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(233).then(function() { return function() { return __webpack_require__(1233); }; }); });
			initExternal(569);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};